module.exports = require('./flow');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/pipe.js
// module id = 1685
// module chunks = 0